





























import { Vue, Component, Prop } from 'vue-property-decorator'
import EditForm from '@/components/EditForm.vue'

const fields = 'id SKU expires license'

@Component({ components: { EditForm }})
export default class CouponForm extends Vue {

	@Prop() coupon

	defaultCoupon = {
		id: '',
		SKU: '',
		expires: '',
		license: ''
	}

	createCoupon = `mutation CreateCoupon($input: CouponInput!) {
		createCoupon(input: $input) { ${ fields } }
	}`
	updateCoupon = `mutation UpdateCoupon($input: CouponInput!) {
		updateCoupon(input: $input) { ${ fields } }
	}`
	deleteCoupon = `mutation DeleteCoupon($id: ID!) {
		deleteCoupon(id: $id) { ${ fields } }
	}`

}
